import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
}
